module.exports = __webpack_public_path__ + "img/2._Bergungsgruppe_A.8d0b062d.svg";